import sliceCreator from '../../index.js';
import {UPDATE_SUBSCRIPTION} from '../../../constants/index.js';
const _updateSubscriptionAction = sliceCreator('UPDATE_SUBSCRIPTION', UPDATE_SUBSCRIPTION, 'put');
 
const { asyncAction: updateSubscriptionAction, reducer, clearData: clearUpdateSubscriptionAction } = _updateSubscriptionAction;
 
export default reducer;
 
export {
    updateSubscriptionAction,
    clearUpdateSubscriptionAction,
}
 